import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", ...t }, /* @__PURE__ */ e.createElement("mask", { id: "mask0_983_6791", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 24, height: 25 }, /* @__PURE__ */ e.createElement("rect", { y: 0.5, width: 24, height: 24, fill: "#D9D9D9" })), /* @__PURE__ */ e.createElement("g", { mask: "url(#mask0_983_6791)" }, /* @__PURE__ */ e.createElement("path", { d: "M12 15.8746L6 9.87461L7.4 8.47461L12 13.0746L16.6 8.47461L18 9.87461L12 15.8746Z", fill: "#7A2C40" })));
export {
  a as default
};
